<template>
    <section>
        <section v-if="isInvalid">
            <div class="alert" v-text="$t('error.invalid_address')"/>
        </section>
    </section>
</template>

<script>
import { matchAddress } from '~/search.js';

export default {
    props: {
        address: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            isInvalid: false,
        };
    },

    async created() {
        const address = await matchAddress(this.address);

        if (!address) {
            this.isInvalid = true;
            return;
        }

        const newRoute = this.$localizeRoute({
            name: 'address',
            params: { address },
        });

        this.$router.replace(newRoute);
    },
};
</script>
